import PinIndex, { ploader, paction } from './createpin';
//import CryptoDeposit from './Crypto';
//import Crypto from './Crypto';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import af from './style.module.scss';

function Pinc() {
  return (
    <div>
      <div className={af.body}>
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const pincroutes = {
  path: `pincreation`,
  //loader: mostrloader(apiContext),
  //, loader: ploader
  element: <Pinc />,
  children: [
    { index: true, element: <PinIndex />, action: paction },
    { path: 'new1', element: <PinIndex />, action: paction },
    /*{
      path: 'crypto',
      element: <CryptoDeposit />,
      //loader: contactLoader,
    },*/
  ],
};
